import React, { useContext } from 'react'
import { LoginQuestionCon } from './styles'
import { AuthContext } from '../../../../Api/firebase'
import { Btn } from '../../../Buttons/Btn'
import { DEFAULT_EXTRA_LOGIN_FIELDS, Question } from '../../../../Api'

type LoginCalloutParams = {
  question: Question
}

export const LoginQuestionCallout: React.FC<LoginCalloutParams> = ({ question }) => {
  const { login } = useContext(AuthContext)!
  let analytics = {
    event: 'question_login_click',
    params: {
      questionId: question.questionId,
      questionName: question.question,
      group: question.group,
    },
  }

  return (
    <LoginQuestionCon>
      <div className="infoCon">
        <h3 className="title">Make it official</h3>
        <p>Log in to keep track of your answers </p>
      </div>
      <Btn
        handleClick={() => login(DEFAULT_EXTRA_LOGIN_FIELDS)}
        btnStyle="primary"
        analytics={analytics}
      >
        Login
      </Btn>
    </LoginQuestionCon>
  )
}
